/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokensDto } from '../../models/tokens-dto';
import { TwoFaAuthDto } from '../../models/two-fa-auth-dto';

export interface TwoFactorAuthControllerAuthenticate$Params {
      body: TwoFaAuthDto
}

export function twoFactorAuthControllerAuthenticate(http: HttpClient, rootUrl: string, params: TwoFactorAuthControllerAuthenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<TokensDto>> {
  const rb = new RequestBuilder(rootUrl, twoFactorAuthControllerAuthenticate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokensDto>;
    })
  );
}

twoFactorAuthControllerAuthenticate.PATH = '/2fa/authenticate';
